import { createStyle } from '@gluestack-style/react';

export const SelectIcon = createStyle({
  props: {
    size: 'md',
  },
});
